export default __webpack_public_path__ + "static/media/save.1d81e59d.jpg";